import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { createGlobalStyle } from 'styled-components';
import resetCss from '../../../../client/reset.css?raw';
import graphikCompact from './graphikCompact';
// TODO: import font
const GlobalStyles = createGlobalStyle `
  // TODO: font
  ${graphikCompact}
  ${resetCss}

  :root {
    --accentColor: initial;
    --accentContrastColor: initial;
    --bgColor: initial;
    --fgColor: initial;
    --gutterWidth: initial;
    --sectionSpacing: initial;
    --sitePadding: initial;
    --siteWidth: initial;
  }

  html {}

  body {
    ${fonts.graphikCompact.regular};

    overscroll-behavior-x: none;
    color: ${brand.primary.purple};
  }

  img {
    max-width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  span {
    display: inline-block;
  }

  sup {
    position: relative;
    top: -0.5em;
    font-size: 80%;
  }

  .hidden {
    display: none;
    visibility: none;
  }

  #main, main {
    > span {
      display: inline;
    }
  }

  .display-contents {
    display: contents;
  }

  html body.equally-ai___monochrome-contrast > :not(#equally-ai___init-access-tool),
  html body.equally-ai___reverse-contrast > :not(#equally-ai___init-access-tool),
  html body.equally-ai___high-saturation > :not(#equally-ai___init-access-tool),
  html body.equally-ai___reverse-contrast.equally-ai___monochrome-contrast > :not(#equally-ai___init-access-tool) {
    filter: none !important;
  }
`;
export default GlobalStyles;
